import type { AddonManagementFilters } from './addonManagement.model';

export type AddonManagementWorkspaceActions =
  | AddonManagementFilterChanged
  | AddonManagementPersistenceFailed
  | AddonManagementFiltersLoaded
  | AddonManagementFiltersLoadingFailed;

export function addonManagementFilterChanged(filters: AddonManagementFilters) {
  return {
    type: 'ADDON_MANAGEMENT_FILTER_CHANGED' as const,
    filters: { ...filters },
  };
}
export type AddonManagementFilterChanged = ReturnType<typeof addonManagementFilterChanged>;

export function addonManagementFiltersPersistenceFailed() {
  return {
    type: 'ADDON_MANAGEMENT_PERSISTENCE_FAILE' as const,
  };
}
export type AddonManagementPersistenceFailed = ReturnType<typeof addonManagementFiltersPersistenceFailed>;

export function addonManagementFiltersLoaded(filters: AddonManagementFilters) {
  return {
    type: 'ADDON_MANAGEMENT_FILTERS_LOADED' as const,
    filters: { ...filters },
  };
}
export type AddonManagementFiltersLoaded = ReturnType<typeof addonManagementFiltersLoaded>;

export function addonManagementFiltersLoadingFailed() {
  return {
    type: 'ADDON_MANAGEMENT_FILTERS_LOADING_FAILED' as const,
  };
}
export type AddonManagementFiltersLoadingFailed = ReturnType<typeof addonManagementFiltersLoadingFailed>;
